import SearchIcon from "../icons/SearchIcon";
import {useEffect, useState} from "react";

export default function SearchOfLeaderPortal({colSize,
                                                 tabButtons,
                                                 activeBtnName,
                                                 tabFun,
                                                 setSearchText,
                                                 setStatusTrans,
                                                 searchText,
                                                 btnProps,
                                                 searchPlaceHolder}) {

    const [activeBtn, setActiveBtn] = useState( activeBtnName ? activeBtnName : tabButtons[0].name)

    useEffect( () => {
        tabFun()
    }, [])


    return(
        <div className={`row justify-content-between`}>

            <div className={`col-4 p-0`}>
                <div className="input-group ltr ">
                    <input type="text"
                           className="formControl"
                           style={{padding: "3%"}}
                           placeholder={searchPlaceHolder ? searchPlaceHolder : "جستجو : کد پیگیری، کدملی، اطلاعات فردی"}
                           value={searchText}
                           onChange={(e) => setSearchText(e.target.value)}
                    />
                    <span
                        className="input-group-text inputGroupText"
                        style={{padding: "2% 4% 2% 0%"}}
                        id="basic-addon2">
                        <span
                            className={`pointer`}
                            onClick={() => tabFun()}
                        ><SearchIcon /></span>
                    </span>

                </div>
            </div>

            {btnProps ?
                <div className={`row ${colSize} p-0 ltr m-0`}>
                    <button
                        className={`col-3 btn border p-0 ${btnProps.classN}`}
                        style={{fontSize: "0.9rem"}}
                        onClick={() => btnProps.setOpenModal(true)}
                    >{btnProps.text} {btnProps.icon}</button>

                    <div className={`col-6 btn-group`}>
                        {
                            tabButtons.map((item, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    style={{fontSize: "0.8rem", padding: "1%"}}
                                    onClick={() => {
                                        setActiveBtn(item.name)
                                        setStatusTrans(item.statusTrans)
                                    }}
                                    className={`btn border text-form-title ${activeBtn == item.name ? 'active_btn' : ''}`}
                                >{item.name}</button>
                            ))
                        }
                    </div>


                </div>
                :
                <div className={`${colSize} btn-group p-0 ltr`}>
                    {
                        tabButtons.map((item, index) => (
                            <button
                                key={index}
                                type="button"
                                style={{fontSize: "0.8rem", padding: "3%"}}
                                onClick={() => {
                                    setActiveBtn(item.name)
                                    setStatusTrans(item.statusTrans)
                                }}
                                className={`btn border text-form-title ${activeBtn == item.name ? 'active_btn' : ''}`}
                            >{item.name}</button>
                        ))
                    }
                </div>
            }

        </div>
    )
}